import { render } from "./StatusComboBox.vue?vue&type=template&id=0d8a6e01"
import script from "./StatusComboBox.vue?vue&type=script&lang=js"
export * from "./StatusComboBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__